module.exports = __webpack_public_path__ + "281496661581c23874e96b62cf6dee61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/home-slide-3.jpg
// module id = 266
// module chunks = 0